export default "__VITE_ASSET__CFZ27sV5__"